import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";
import FoodpackageListTable from './Components/FoodpackageListTable'


const FoodpackageList = () => {
    
    return (
            <PageBody
                card={true}
                headerchildren={
                    <>
                    <HeadingOne>Food Package List</HeadingOne>
                    <AddItemBtn url="add-food-package" title="Create" />
                    </>
                }>

                {/* Table section */}
                <div className="col-12">
                    <FoodpackageListTable />
                </div>
            </PageBody>
    );
};

export default FoodpackageList;
